export default __webpack_public_path__ + "static/1537-f5b735c122ed78f6185a87e545dc46a1.gif";